import React from "react";
import { useFormikContext } from "formik";
import Button from "../Button";
import { ButtonSize } from "../Button/styles";

const SubmitButton = (props: Props) => {
  const { isSubmitting } = useFormikContext();
  const { submittingText = "Saving...", children = "Save", size } = props;

  return (
    <Button type="submit" primary disabled={isSubmitting} size={size}>
      {isSubmitting ? submittingText : children}
    </Button>
  );
};

type Props = {
  submittingText?: string;
  children?: string;
  size?: ButtonSize;
};

export default SubmitButton;
